import $ from "jquery";
import cookie from "js-cookie";
import _uniq from "lodash/uniq";

import config from "js/config";
import model from "js/models/questions";

export function getUserID() {
    const uid = (window.heap && window.heap.identity) || cookie.get("_ws_heap") || window.uid;
    return Number(uid);
}

export function isGutCheckTest() {
    return !window.complete;
}

export function isConfirmPhoneTest() {
    return true;
}

export function scroll() {
    const errors = $(".help-block:not(.hidden)");
    if (errors.length) {
        const offset = errors.first().offset().top - 50;
        const $el = $(".jquery-modal").is(":visible") ? $(".jquery-modal") : $("body");
        $el.animate({ scrollTop: $el.scrollTop() + offset }, "slow");
        $(".help-block").fadeTo(100, 0.2, function fadeComplete() {
            $(this).fadeTo(500, 1.0);
        });
    }
}

export function showModal($el, options = {}) {
    $el.modal({
        closeClass: "icon-close",
        closeText: "&times;",
        fadeDuration: 350,
        fadeDelay: 0,
        ...options,
    });
}

export class GutCheck {
    constructor(userModel) {
        this.model = userModel;
        this.experienceMonths = this.getJobs().getDuration();

        const skills = this.getSkills();
        this.highestSkill = skills.reduce((max, skill) => {
            const months = skill.getMonths();
            if (!max) {
                return months ? skill : null;
            }
            return max.getMonths() >= months ? max : skill;
        }, null);

        this.missingKeywords = this.getMissingKeywords();
    }

    isMissingExperience() {
        return this.highestSkill && this.highestSkill.getMonths() > this.experienceMonths;
    }

    isMissingKeywords() {
        return this.missingKeywords.length > 0;
    }

    getMissingKeywords() {
        const jobs = this.getJobs();
        const skills = this.getSkills();

        const missing = skills.filter((skill) => {
            const keywords = skill.getKeywords();

            // If they said they have zero experience
            if (keywords.length === 0) {
                return false;
            }

            for (let i = 0; i < jobs.length; i += 1) {
                const job = jobs.at(i);
                if (job.hasAnyKeyword(keywords)) {
                    return false;
                }
            }

            return !this.model.hasAckedKeyword(keywords[0]);
        });

        return missing.map((q) => q.id);
    }

    getJobs() {
        return this.model.get("jobs").getJobs();
    }

    getSkills() {
        if (!this.skills) {
            this.skills = this.model.getAnsweredSkills().map((q) => new model.Question(q));
        }

        return this.skills;
    }

    getKeywords() {
        if (this.keywords) {
            return this.keywords;
        }

        let keywords = [];
        this.getSkills().forEach((skill) => {
            keywords = keywords.concat(skill.getKeywords());
        });

        this.keywords = _uniq(keywords);
        return this.keywords;
    }

    getPrimaryKeywords() {
        const missing = this.missingKeywords;
        const max = config.GUT_CHECK_MAX_KEYWORDS;
        const keywords = [];

        this.getSkills().forEach((skill) => {
            const kw = skill.getKeywords();
            const answer = skill.getAnswerFromResponse() || {};

            // Only display <=4 of the missing keywords for gut check UI
            if (kw.length > 0 && missing.indexOf(skill.id) > -1 && keywords.length < max) {
                keywords.push({
                    keyword: kw[0],
                    answer: answer.value,
                });
            }
        });

        return _uniq(keywords);
    }
}
